export const getJobTypes = () => {
  return [
    {
      value: 'create-run',
      label: 'create-run'
    },
    {
      value: 'create-run-consolidate',
      label: 'create-run-consolidate'
    }
  ]
}

export const getTimezones = () => {
  // const timezoness = moment.tz.names().map((tmz) => ({
  //   label:moment().tz(tmz).zoneAbbr(),
  //   value: moment().tz(tmz).format('Z')
  // }))

  // const groupedTimezones = keys(groupBy(timezoness, 'key')).map((key) => {
  //   const value = first(groupBy(timezoness, 'key')[key]).value
  //   return {
  //     label:`${key} ${value}`,
  //     value: `${key} ${value}`
  //   }
  // })

  return [
    {
      label: 'UTC +00:00',
      value: 'UTC +00:00'
    },
    {
      label: 'GMT +00:00',
      value: 'GMT +00:00'
    },
    {
      label: 'CEST +02:00',
      value: 'CEST +02:00'
    },
    {
      label: 'EAT +03:00',
      value: 'EAT +03:00'
    },
    {
      label: 'CET +01:00',
      value: 'CET +01:00'
    },
    {
      label: 'WAT +01:00',
      value: 'WAT +01:00'
    },
    {
      label: 'CAT +02:00',
      value: 'CAT +02:00'
    },
    {
      label: 'EET +02:00',
      value: 'EET +02:00'
    },
    {
      label: 'SAST +02:00',
      value: 'SAST +02:00'
    },
    {
      label: 'HDT -09:00',
      value: 'HDT -09:00'
    },
    {
      label: 'AKDT -08:00',
      value: 'AKDT -08:00'
    },
    {
      label: 'AST -04:00',
      value: 'AST -04:00'
    },
    {
      label: 'EST -05:00',
      value: 'EST -05:00'
    },
    {
      label: 'CST -06:00',
      value: 'CST -06:00'
    },
    {
      label: 'MDT -06:00',
      value: 'MDT -06:00'
    },
    {
      label: 'CDT -05:00',
      value: 'CDT -05:00'
    },
    {
      label: 'MST -07:00',
      value: 'MST -07:00'
    },
    {
      label: 'EDT -04:00',
      value: 'EDT -04:00'
    },
    {
      label: 'PDT -07:00',
      value: 'PDT -07:00'
    },
    {
      label: 'ADT -03:00',
      value: 'ADT -03:00'
    },
    {
      label: 'NDT -02:30',
      value: 'NDT -02:30'
    },
    {
      label: 'AEST +10:00',
      value: 'AEST +10:00'
    },
    {
      label: 'NZST +12:00',
      value: 'NZST +12:00'
    },
    {
      label: 'EEST +03:00',
      value: 'EEST +03:00'
    },
    {
      label: 'IST +05:30',
      value: 'IST +05:30'
    },
    {
      label: 'HKT +08:00',
      value: 'HKT +08:00'
    },
    {
      label: 'WIB +07:00',
      value: 'WIB +07:00'
    },
    {
      label: 'WIT +09:00',
      value: 'WIT +09:00'
    },
    {
      label: 'IDT +03:00',
      value: 'IDT +03:00'
    },
    {
      label: 'PKT +05:00',
      value: 'PKT +05:00'
    },
    {
      label: 'WITA +08:00',
      value: 'WITA +08:00'
    },
    {
      label: 'PST +08:00',
      value: 'PST +08:00'
    },
    {
      label: 'KST +09:00',
      value: 'KST +09:00'
    },
    {
      label: 'JST +09:00',
      value: 'JST +09:00'
    },
    {
      label: 'WEST +01:00',
      value: 'WEST +01:00'
    },
    {
      label: 'ACST +09:30',
      value: 'ACST +09:30'
    },
    {
      label: 'AWST +08:00',
      value: 'AWST +08:00'
    },
    {
      label: 'BST +01:00',
      value: 'BST +01:00'
    },
    {
      label: 'MSK +03:00',
      value: 'MSK +03:00'
    },
    {
      label: 'HST -10:00',
      value: 'HST -10:00'
    },
    {
      label: 'MEST +02:00',
      value: 'MEST +02:00'
    },
    {
      label: 'ChST +10:00',
      value: 'ChST +10:00'
    },
    {
      label: '-0930 -09:30',
      value: '-0930 -09:30'
    },
    {
      label: 'SST -11:00',
      value: 'SST -11:00'
    },
    {
      label: '-03 -03:00',
      value: '-03 -03:00'
    },
    {
      label: '-04 -04:00',
      value: '-04 -04:00'
    },
    {
      label: '+1245 +12:45',
      value: '+1245 +12:45'
    },
    {
      label: '+03 +03:00',
      value: '+03 +03:00'
    },
    {
      label: '+02 +02:00',
      value: '+02 +02:00'
    },
    {
      label: '+06 +06:00',
      value: '+06 +06:00'
    },
    {
      label: '+12 +12:00',
      value: '+12 +12:00'
    },
    {
      label: '+04 +04:00',
      value: '+04 +04:00'
    },
    {
      label: '+09 +09:00',
      value: '+09 +09:00'
    },
    {
      label: '+0530 +05:30',
      value: '+0530 +05:30'
    },
    {
      label: '+0430 +04:30',
      value: '+0430 +04:30'
    },
    {
      label: '+0545 +05:45',
      value: '+0545 +05:45'
    },
    {
      label: '+0630 +06:30',
      value: '+0630 +06:30'
    },
    {
      label: '+0330 +03:30',
      value: '+0330 +03:30'
    },
    {
      label: '-01 -01:00',
      value: '-01 -01:00'
    },
    {
      label: '+0845 +08:45',
      value: '+0845 +08:45'
    },
    {
      label: '+1030 +10:30',
      value: '+1030 +10:30'
    },
    {
      label: '-06 -06:00',
      value: '-06 -06:00'
    },
    {
      label: '-10 -10:00',
      value: '-10 -10:00'
    },
    {
      label: '-11 -11:00',
      value: '-11 -11:00'
    },
    {
      label: '-12 -12:00',
      value: '-12 -12:00'
    },
    {
      label: '-07 -07:00',
      value: '-07 -07:00'
    },
    {
      label: '-08 -08:00',
      value: '-08 -08:00'
    },
    {
      label: '-09 -09:00',
      value: '-09 -09:00'
    },
    {
      label: '+01 +01:00',
      value: '+01 +01:00'
    },
    {
      label: '+13 +13:00',
      value: '+13 +13:00'
    },
    {
      label: '+14 +14:00',
      value: '+14 +14:00'
    },
    {
      label: '+00 +00:00',
      value: '+00 +00:00'
    },
    {
      label: '-05 -05:00',
      value: '-05 -05:00'
    },
    {
      label: '-02 -02:00',
      value: '-02 -02:00'
    },
    {
      label: '+11 +11:00',
      value: '+11 +11:00'
    },
    {
      label: '+07 +07:00',
      value: '+07 +07:00'
    },
    {
      label: '+10 +10:00',
      value: '+10 +10:00'
    },
    {
      label: '+05 +05:00',
      value: '+05 +05:00'
    },
    {
      label: '+08 +08:00',
      value: '+08 +08:00'
    }
  ]
}

export const getWeekdays = (t) => [
  {
    label: t('JobExpression.MONDAY'),
    value: '1'
  },
  {
    label: t('JobExpression.TUESDAY'),
    value: '2'
  },
  {
    label: t('JobExpression.WEDNESDAY'),
    value: '3'
  },
  {
    label: t('JobExpression.THURSDAY'),
    value: '4'
  },
  {
    label: t('JobExpression.FRIDAY'),
    value: '5'
  },
  {
    label: t('JobExpression.SATURDAY'),
    value: '6'
  },
  {
    label: t('JobExpression.SUNDAY'),
    value: '7'
  }
]

export const getMonths = (t) => [
  {
    label: t('JobExpression.JANUARY'),
    value: '1'
  },
  {
    label: t('JobExpression.FEBRUARY'),
    value: '2'
  },
  {
    label: t('JobExpression.MARCH'),
    value: '3'
  },
  {
    label: t('JobExpression.APRIL'),
    value: '4'
  },
  {
    label: t('JobExpression.MAY'),
    value: '5'
  },
  {
    label: t('JobExpression.JUNE'),
    value: '6'
  },
  {
    label: t('JobExpression.JULY'),
    value: '7'
  },
  {
    label: t('JobExpression.AUGUST'),
    value: '8'
  },
  {
    label: t('JobExpression.SEPTEMBER'),
    value: '9'
  },
  {
    label: t('JobExpression.OCTOBER'),
    value: '10'
  },
  {
    label: t('JobExpression.NOVEMBER'),
    value: '11'
  },
  {
    label: t('JobExpression.DECEMBER'),
    value: '12'
  }
]

export const getWeekNumbers = (t) => [
  {
    label: 'N/A',
    value: ''
  },
  {
    label: t('JobExpression.FIRST'),
    value: 1
  },
  {
    label: t('JobExpression.SECOND'),
    value: 2
  },
  {
    label: t('JobExpression.THIRD'),
    value: 3
  },
  {
    label: t('JobExpression.FOURTH'),
    value: 4
  },
  {
    label: t('JobExpression.LAST'),
    value: 'L'
  }
]
